// extracted by mini-css-extract-plugin
export default {"banner":"OfflineBanner_banner__t4enJ","icoon":"OfflineBanner_icoon__NzmML","tekst":"OfflineBanner_tekst__PjXUv"};